import { useL10n } from "@ews/react-localization-context";
import { IonInput, IonItem, IonLabel } from "@ionic/react";
import React, { useCallback, useRef } from "react";
import { useIsMobile } from "../../../Responsive";
import globalStyle from '../GlobalSettings.module.scss';
import style from './SettingsNumberInput.module.scss';
import { SettingsNumberInputProps } from "./types";
import { InputChangeEventDetail, InputInputEventDetail } from "@ionic/core";

const SettingsNumberInput: React.FC<SettingsNumberInputProps> = ({
    endText = '',
    startText = '',
    onChange,
    value,
    inputType = "number",
    hidden = false,
    labelPosition = 'stacked',
    text = '',
    tooltip,
    disabled,
    hasFocus,
    required,
    lines = undefined,
    debounce,
    onFocus,
    onBlur,
    id,
    inputRef,
    min,
    max,
    step
}) =>
{
    const { translate: t } = useL10n();
    const mobileView = useIsMobile();
    const inputStyle = mobileView ? 'mobileInput' : 'webInput';
    const InputValue = useRef<number | null | undefined>(value);
    const innerInputRef = useRef<HTMLIonInputElement>(null);


    const handleFocusAfterReload = useCallback((ref: React.RefObject<HTMLIonInputElement>) =>
    {
        ref.current?.setFocus();
    }, []);

    const _hasFocus = useRef<boolean>(false);


    const handleFocusOut = useCallback(() =>
    {
        _hasFocus.current = false;
    }, []);
    const handleFocusIn = useCallback(() =>
    {
        _hasFocus.current = true;
    }, []);


    const handleChange = useCallback((detail: InputInputEventDetail | InputChangeEventDetail) =>
    {
        const value = Number(detail.value);
        InputValue.current = value;
        if (onChange) onChange(value);
    }, [InputValue, onChange]);

    function hangleTextTranslation(str: string)
    {
        if (!text.includes(",")) {
            return t(text);
        }
        return text.split(",").map((text, index) =>
        {
            const translaiton = t(text.trim());

            return index !== 0 ? ` ${translaiton}` : translaiton;
        }).join("");
    }

    if (hasFocus) handleFocusAfterReload(inputRef || innerInputRef);

    return <IonItem hidden={hidden} lines={lines} className={`${style.overflow} ${globalStyle.setting} ${hasFocus ? style.hasFocus : ''}`}>
        <div className={style.container} style={{ width: "100%" }}>
            <div className={style.containerInput}>
                <span className={`${style.flex} ${style.justifyStart}`}>
                    <IonLabel
                        style={{ whiteSpace: "break-spaces" }}
                        position={labelPosition}>
                        {`${startText}${hangleTextTranslation(text)}${endText}`}{required ? <span className={`${globalStyle.required}`}>*</span> : null}
                    </IonLabel>
                    <span className={style.tooltip}>
                        {mobileView ? <></> : tooltip}
                    </span>
                </span>
                <IonInput
                    ref={inputRef || innerInputRef}
                    label=""
                    id={id}
                    max={max}
                    min={min}
                    step={step}
                    debounce={debounce}
                    onIonFocus={() =>
                    {
                        handleFocusIn();
                        if (onFocus) onFocus();
                    }
                    }
                    onIonBlur={(e) =>
                    {

                        handleFocusOut();
                        if (onBlur) onBlur({ value: InputValue.current!, focus: _hasFocus.current, event: e });
                    }}
                    required={required}
                    disabled={disabled}
                    value={value || 0}
                    type={inputType}
                    className={`${style.inputAlign} ${globalStyle[inputStyle]} ${style.noArrows}`}
                    onIonInput={({ detail }) =>
                    {
                        if (debounce) handleChange(detail);
                    }}
                    onIonChange={({ detail }) =>
                    {
                        if (!debounce) handleChange(detail);


                    }} />
            </div>
        </div>
    </IonItem>;
};

export default SettingsNumberInput;